import styled from 'styled-components';

export const SuggestionContainer = styled.span`
  pointer-events: none;
  position: relative;
  z-index: 1;
`;
